<template>

    <div class="mb-4">
        <booking-summary></booking-summary>
        <div class="mb-4">
            <current-action v-bind:action="'Can we make your stay even more special?'"></current-action>
        </div>

    </div>
    <div v-if="!isLoading">
        <div class="container">
            <div class="row ">

                <div class="col-xl-8 mb-4 "
                     v-for="p in perItemPackages"
                     v-bind:key="p.Code">
                    <package-panel v-bind:availability="p"
                                   v-bind:isHorizontal="true">

                    </package-panel>

                </div>

                <div class="col-xl-8 mb-4 "
                     v-for="p in nonPerItemPackages"
                     v-bind:key="p.Code">
                    <package-panel v-bind:availability="p"
                                   v-bind:isHorizontal="true">

                    </package-panel>

                </div>



            </div>





        </div>
    </div>
    <div class="d-flex justify-content-center" v-if="isLoading">
        <loader></loader>
    </div>




    <actions-bar>
        <template v-slot:actions>
            <div class="row">
                <div class="col-12">

                    <button v-on:click="onBack"
                            type="button"
                            class="btn btn--transparent btn--back">
                        Back
                    </button>
                </div>
                <div class="col-12 justify-content-end d-flex">
                    <button class="btn btn--slate-blue btn--continue"
                            v-on:click="onContinue">
                        Continue
                    </button>
                </div>
            </div>

        </template>
    </actions-bar>





</template>



<script>
    import { _ } from 'vue-underscore';
    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import Loader from '@/shared/components/Loader.vue';

    import BookingSummary from '../components/BookingSummary.vue';

    import CurrentAction from '../components/CurrentAction.vue';

    import PackagePanel from '../components/PackagePanel.vue';

    import { store } from '../store/index';



    export default {
        name: 'StayAddOns',

        components: {
            ActionsBar,
            BookingSummary,
            CurrentAction,
            PackagePanel,
            Loader
        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            search() {
                return store.getters.search;
            },
            packages() {
                let availability = store.getters.packageAvailability;
                let configuration = store.getters.roomConfiguration.AddOns;


                let booking = this.booking;
                var rateGroupsRates = booking.legs.map(item => item.rate.rateGroupRate.AllowedAddOnPackages);
                var allowedRateCodes = _.union(...rateGroupsRates);

                let result = [];


            

                for (var ai in availability) {
                    let packageAvailability = availability[ai];

                    let content = configuration.find(item => item.PMSCode == packageAvailability.Code);

                    //lets first check if we have any content - if ther eis no content, we can't show...
                    if (content == null) {
                        continue;
                    }

                    //now check any of our rates support the pacakge...

                    if (!allowedRateCodes.includes(packageAvailability.Code)) {
                        continue;
                    }

                    //need to check all is available
                    
                    if (content.MinOccupancy != null) {
                
                        let minAdults = _.min(this.booking.legs.map((item) => item.guestQuota.Adults));
                        if (minAdults < content.MinOccupancy) {
                            continue;
                        }
                    }

                    //need to check days of week here for pacakge...
                    if (content.Restaurant != null) {
                        if (!this.restaurantIsAvailable(content.Restaurant)) {
                            continue;
                        }
                    }



                    let packageResult = {
                        availability: packageAvailability,
                        content,
                        quantity: 1
                    };


                    result.push(packageResult);


                }

                return result;
            },

            perItemPackages() {
                if (this.packages.length) {


                    return this.packages.filter(p => !p.content.IsGolf && p.content.Restaurant == null && p.content.Spa == null);
                }
                return [];
            },

            nonPerItemPackages() {
                if (this.packages.length) {
                    return this.packages.filter(p => p.content.IsGolf || p.content.Restaurant != null || p.content.Spa);
                }
                return [];
            }

        },

        data() {
            return {

                isLoading: false
            }
        },
        mounted() {
            this.isLoading = true;
            this.trackAddOns();

            if (!this.packages.length) {
                this.$router.push({ name: 'stay_details', params: { id: this.session.Id } });
            }

            this.isLoading = false;


        },
        methods: {
            onContinue: function () {





                this.$router.push({ name: 'stay_details', params: { id: this.session.Id } });
            },
            onBack: function () {
                this.$router.push({ name: 'stay_itinerary', params: { id: this.session.Id } });
            },
            restaurantIsAvailable(restaurant) {
                let result = [];
                let daysOpened = restaurant.DaysOpened;

                let dayDelta = moment(this.booking.arrivalDate);
                let numberOfNights = +this.booking.numberOfNights;

                for (let ni = 0; ni < numberOfNights; ni++) {
                    let thisDay = moment(dayDelta).add(ni, 'd').day();

                    switch (thisDay) {
                        case 0:
                            result.push(daysOpened.Sunday);
                        case 1:
                            result.push(daysOpened.Monday);
                        case 2:
                            result.push(daysOpened.Tuesday);
                        case 3:
                            result.push(daysOpened.Wednesday);
                        case 4:
                            result.push(daysOpened.Thursday);
                        case 5:
                            result.push(daysOpened.Friday);
                        case 6:
                            result.push(daysOpened.Saturday);
                    }
                }


                return _.contains(result, true);
            },

            trackAddOns() {

                if (this.$gtm.enabled()) {

                    let items = [];

                    for (let i = 0; i < this.packages.length; i++) {
                        let main = this.packages[i];

                        let item = {
                            'item_id': main.availability.Code,
                            'item_name': main.content.DisplayName,
                            'item_list_name': 'Add On',
                            'price': main.availability.Amount
                        };
                        items.push(item);
                    }

                    window.dataLayer?.push({
                        'pageURL': '/stay/add-ons',
                        'event': 'view_item_list',
                        'ecommerce': {
                            'item_list_name': 'Add Ons Availability',
                            'items': items
                        }
                    });
                }

            },


        },

    }
</script>

<style src="@/modules/stay/css/add-ons.css"></style>
